<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addGoodsCategory">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
        <a-table
        :defaultExpandAllRows="true"
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 345px)' }"
        :pagination="false"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="name"
          :title="$t('NAME') || '名称'"
          width="100">
        </a-table-column>
<!--         <a-table-column-->
<!--          data-index="code"-->
<!--          :title="$t('CODE') || '编码'"-->
<!--          width="100">-->
<!--        </a-table-column>-->
         <a-table-column
          data-index="coverPath"
          :title="$t('COVER') || '背景图'"
          width="80">
           <template slot-scope="text,record">
            <a-avatar
              :src="record.coverPath"
              class="antd-pro-global-header-index-avatar"/>
          </template>
        </a-table-column>
       <a-table-column
         :title="$t('SERIES') || '系列'">
            <template slot-scope="text, record">
              {{ record.series.name }}
            </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button
              type="link"
              @click="editGoodsCategory(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button
            type="link"
            @click="viewGoodsCategory(record.id)">{{ $t('DETAIL') || '详情' }}
            </a-button>
            <a-button
              type="link"
              @click="upGoodsCategory(record.id)">{{ $t('UP') || '上移' }}</a-button>
            <a-button
              type="link"
              @click="downGoodsCategory(record.id)">{{ $t('DOWN') || '下移' }}</a-button>
            <a-button
              type="link"
              @click="deleteGoodsCategory(record.id)">{{ $t('DELETE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
        :footer="null"
        title="商品分类编辑"
        v-model="form.visible">
      <goodsCategory-edit
        v-if="form.visible"
        :goods-category-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </goodsCategory-edit>
    </a-modal>
    <a-modal
      :footer="null"
      title="商品属性"
      append-to-body
      v-model="attributeForm.visible">
      <goods-attribute-list
        v-if="attributeForm.visible"
        :goods-category-id="attributeForm.data.id">
      </goods-attribute-list>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryGoodsCategories,
  _deleteGoodsCategory,
  _downGoodsCategory,
  _upGoodsCategory,
} from '@/api/goodsCategoryApi';
import GoodsCategoryEdit from './GoodsCategoryEdit.vue';
import GoodsAttributeList from '../goodsAttribute/GoodsAttributeList.vue';

async function getGoodsCategoryList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsCategories({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content.filter(x => !x.parentId)
    .map(x => (
      {
        ...x,
        children: getChildren(result.content, x.id),
      }
    ));
  this.table.data.forEach(element => {
    if (element.children.length === 0) {
      delete element.children;
    }
  });
  // console.log(this.table.data);
  const list = this.table.data.filter(item => item.seriesId !== '1531903218005708800');
  this.table.data = list;
  // console.log(list);
}

function editGoodsAttribute(id) {
  this.attributeForm.data.id = id;
  this.attributeForm.visible = true;
}

function addGoodsCategory() {
  this.form.data.id = null;
  this.form.visible = true;
}

function getChildren(categoryList, parentId) {
  const secondlist = categoryList.filter(x => x.parentId === parentId).map(x => ({
    ...x,
    children: categoryList.filter(y => y.parentId === x.id)
  })
  );
  // 根据是否含有children 来决定是否删除该属性
  secondlist.forEach(element => {
    if (element.children.length === 0) {
      delete element.children;
    }
  });
  return secondlist;
}

function editGoodsCategory(goodsCategoryId) {
  this.form.data.id = goodsCategoryId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsCategoryList();
}
function viewGoodsCategory(categoryId) {
  this.$router.push(`/goods-category/${categoryId}`);
}

async function deleteGoodsCategory(goodsCategoryId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deleteGoodsCategory(goodsCategoryId);
      if (result) {
        this.$message.success('删除成功');
        this.getGoodsCategoryList();
      }
    },
  });
}

async function upGoodsCategory(goodsCategoryId) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upGoodsCategory(goodsCategoryId);
      this.$message.success('上移成功');
      this.getGoodsCategoryList();
    },
  });
}

async function downGoodsCategory(goodsCategoryId) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downGoodsCategory(goodsCategoryId);
      this.$message.success('下移成功');
      this.getGoodsCategoryList();
    },
  });
}

export default {
  name: 'GoodsCategoryList',
  components: {
    GoodsAttributeList,
    GoodsCategoryEdit,
  },
  data() {
    return {
      expandedRowKeys: [],
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      attributeForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 999,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getGoodsCategoryList,
    editGoodsAttribute,
    deleteGoodsCategory,
    editGoodsCategory,
    addGoodsCategory,
    upGoodsCategory,
    downGoodsCategory,
    closeForm,
    viewGoodsCategory,
  },
  created() {
    this.getGoodsCategoryList();
  },
};
</script>

<style scoped>

</style>
